import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'chunk_split',
    standalone: false
})
export class ChunkSplitPipe implements PipeTransform {
  transform(value: string, chunklen: number, replace: string) : string {
    chunklen = chunklen || 76;
    replace = replace || '\r\n';

    if (!value || chunklen < 1) {
      return '';
    }
    var CharsCount = 6;
    value = new Array(value.length - CharsCount + 1).join('x') + value.slice(-CharsCount);

    return value.match(new RegExp(".{0," + chunklen + "}", "g")).join(replace);
  }
}